import React, { useEffect, useState } from "react";
import CallCardSmall from "./CallCardSmall";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { Divider, IconButton } from "@mui/material";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningIcon from "@mui/icons-material/Warning";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import NoCallsCard from "./NoCallsCard";
import CancelCallModal from "../Structure/CancelCallModal";
import { useTranslation } from "react-i18next";

function CallsArea({ collapse, data, remakeCall, cancelCall }) {
  // 1) Data
  const { t } = useTranslation();
  const [startIndex, setStartIndex] = useState(0);
  const visibleTrips = data.slice(startIndex, startIndex + 3);
  const oneVisibleTrip = data.slice(startIndex, startIndex + 1);
  const [firstLoad, setfirstLoad] = useState(true);
  const [showModal, setshowModal] = useState(false);
  const [cancelObject, setcancelObject] = useState();

  const handlePrevClick = () => {
    setStartIndex(Math.max(startIndex - 1, 0));
  };

  const handleNextClick = () => {
    setStartIndex(Math.min(startIndex + 1, data.length - 3));
  };
  const handleNextClickOneSection = () => {
    setStartIndex(Math.min(startIndex + 1, data.length - 1));
  };

  //useEffect
  useEffect(() => {
    if (!firstLoad) {
    } else setfirstLoad(false);

    return;
  }, [data]);

  // 3) Function
  const CardBlock = ({ data, index }) => {
    if (data.info.callStatus === 30 || data.info.callStatus === 31)
      return (
        <>
          <div key={data.info.callID} className="py-3">
            {/* Title */}
            <div className=" px-3 pb-1 flex items-center">
              <CancelIcon className="text-red-500" />
              <div className=" text-gray-500 lg:text-base text-sm px-3">
                {t("Η_κλήση_ακυρώθηκε")}
              </div>
            </div>

            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Address")} </div>
              <div className="font-semibold">{" " + data.info.destination}</div>
            </div>
            <Divider />

            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Στοιχεία_ΤΑΞΙ")}</div>
              <div className="font-semibold">{" " + data.info.taxiNo}</div>
            </div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Όνομ/μο_Οδηγού")}</div>
              <div className="font-semibold">
                {" " + data.driverFirstName + " " + data.driverLastName}
              </div>
            </div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Όνομ/μο_Πελάτη")}</div>
              <div className="font-semibold">
                {" " + data.info.customerName}
              </div>
            </div>
          </div>
        </>
      );
    else if (data.info.callStatus === 10 || data.info.callStatus === 11)
      return (
        <>
          <div key={data.info.callID} className="py-3">
            {/* Title */}
            <div className=" px-3 pb-1 flex justify-between items-center">
              <div className="flex items-center">
                <CheckCircleOutlineIcon className="text-green-500" />
                <div className=" text-gray-500 text-base px-3">
                  {t("Το_όχημα_έχει_βρεθεί")}
                </div>
              </div>
              <CancelIcon
                onClick={() => {
                  setcancelObject(data);
                  setshowModal(true);
                }}
                className="text-red-500 cursor-pointer hover:scale-125"
              />
            </div>

            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Διεύθυνση-Απόσταση-Χρόνος")} </div>
              <div className="font-semibold">
                {data.info.destination}
                {data.distance == undefined && "  "}
                {data.distance != undefined && " - " + data.distance}
                {data.duration == undefined && "  "}
                {data.duration != undefined && (
                  <>
                    {" - "}
                    <span className="bg-green-400 p-0.5">{data.duration}</span>
                  </>
                )}
              </div>
            </div>
            <Divider />

            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Στοιχεία_ΤΑΞΙ")}</div>
              <div className="font-semibold">
                {t("Κωδ.")}
                {" " +
                  data.info.taxiNo +
                  " - " +
                  t("Πινακίδα") +
                  " " +
                  data.taxiLicNo}
              </div>
            </div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Όνομ/μο_Οδηγού")}</div>
              <div className="font-semibold">
                {" " + data.driverFirstName + " " + data.driverLastName}
              </div>
            </div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Όνομ/μο_Πελάτη")}</div>
              <div className="font-semibold">
                {" " + data.info.customerName}
              </div>
            </div>
          </div>
        </>
      );
    else if (data.info.callStatus === 20 || data.info.callStatus === 21)
      return (
        <>
          <div key={data.info.callID} className="py-3">
            {/* Title */}
            <div className=" px-3 pb-1 flex items-center">
              <WarningIcon className="text-yellow-500" />
              <div className=" text-gray-500 text-base px-3">
                {t("Το_όχημα_δε_βρέθηκε")}
              </div>
            </div>

            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Address")} </div>
              <div className="font-semibold">{" " + data.info.destination}</div>
            </div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Όνομ/μο_Πελάτη")}</div>
              <div className="font-semibold">
                {" " + data.info.customerName}
              </div>
            </div>

            <Divider />
            <div className="px-3 pt-5 flex justify-center  mb-0.5">
              <div
                onClick={() => remakeCall(data.info)}
                className="Primary_Main_Background text-white p-2 rounded-full hover:scale-110 cursor-pointer"
              >
                {t("Επανάληψη_κλήσης")}
              </div>
            </div>
          </div>
        </>
      );
    else if (data.info.callStatus === 0 || data.info.callStatus === 1)
      return (
        <>
          <div key={data.info.callID} className="py-3">
            {/* Title */}
            <div className=" px-3 pb-1 flex items-center">
              <img
                src={require("../../Images/Universal/hourglass.gif")}
                width={30}
              />
              <div className=" text-gray-500 text-base px-3">
                {t("Αναζήτηση_οχήματος")}
              </div>
            </div>

            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Address")}</div>
              <div className="font-semibold">{" " + data.info.destination}</div>
            </div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">{t("Όνομ/μο_Πελάτη")}</div>
              <div className="font-semibold">
                {" " + data.info.customerName}
              </div>
            </div>
          </div>
        </>
      );
    else {
      return (
        <>
          <div key={data.info.callID} className="py-3">
            {/* Title */}
            <div className=" px-3 pb-1 flex items-center">
              <img
                src={require("../../Images/Universal/call.png")}
                width={30}
              />
              <div className=" text-gray-500 text-base px-3">{t("Error")}</div>
            </div>

            <div className="px-3 pt-1 mb-0.5"></div>

            <Divider />
            <div className="px-3 pt-1 mb-0.5">
              <div className="">
                {t("Something went wrong with call status.")}
              </div>
            </div>
          </div>
        </>
      );
    }
  };

  return (
    <>
      {/* Data */}
      {data.length <= 0 ? (
        <NoCallsCard />
      ) : (
        <>
          {collapse ? (
            <>
              <div
                style={{
                  overflowY: "hidden",
                  marginLeft: "auto",
                  marginRight: "auto",
                  textAlign: "center",
                }}
                className=" max-w-3xl p-3 max-h-48 mt-10  w-full bottom-10  flex "
              >
                {data.map((element, index) => {
                  return (
                    <React.Fragment key={index}>
                      <CallCardSmall
                        element={element}
                        index={index}
                        remakeCall={remakeCall}
                        setshowModal={setshowModal}
                        setcancelObject={setcancelObject}
                      />
                    </React.Fragment>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              {data.length > 2 ? (
                <>
                  {/* 3 Blocks Sections */}
                  <div className=" mt-8 justify-around items-center w-full pb-5 hidden md:flex">
                    {/* Left Button */}
                    <div
                      className={`mx-2 ${
                        startIndex === 0 ? "opacity-50 " : ""
                      }`}
                      onClick={handlePrevClick}
                      disabled={startIndex === 0}
                    >
                      <IconButton className="Primary_Light_Background hover:scale-110">
                        <ArrowBackIosNewIcon />
                      </IconButton>
                    </div>

                    {/* Cards */}
                    <div className="flex justify-center w-full">
                      {visibleTrips.map((trip, index) => (
                        <div
                          key={index}
                          className="w-full rounded overflow-hidden shadow-lg bg-gray-200 mx-4"
                        >
                          <CardBlock data={trip} index={index} />
                        </div>
                      ))}
                    </div>

                    {/* Right Button */}
                    <div
                      className={`mx-2 ${
                        startIndex === data.length - visibleTrips.length
                          ? "opacity-50 "
                          : ""
                      }`}
                      onClick={handleNextClick}
                      disabled={
                        startIndex === data.length - visibleTrips.length
                      }
                    >
                      <IconButton className="Primary_Light_Background hover:scale-110">
                        <ArrowForwardIosIcon />
                      </IconButton>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className=" mt-8 justify-around items-center w-full pb-5 hidden md:flex">
                    {/* Cards */}
                    <div className="flex justify-center w-full">
                      {visibleTrips.map((trip, index) => (
                        <div
                          key={index}
                          className=" rounded overflow-hidden shadow-lg bg-gray-200 mx-4"
                        >
                          <CardBlock data={trip} index={index} />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              )}
              {/* 1 Block Section */}
              <div className=" mt-8 flex justify-between items-center pb-5  md:hidden">
                {/* Left Button */}
                <div
                  className={`mx-2 ${startIndex === 0 ? "opacity-50 " : ""}`}
                  onClick={handlePrevClick}
                  disabled={startIndex === 0}
                >
                  <IconButton className="Primary_Light_Background hover:scale-110">
                    <ArrowBackIosNewIcon />
                  </IconButton>
                </div>

                {/* Cards */}
                <div className="flex justify-center w-full">
                  {oneVisibleTrip.map((trip, index) => (
                    <div
                      key={index}
                      className="w-full rounded overflow-hidden shadow-lg bg-gray-200 mx-4"
                    >
                      <CardBlock data={trip} index={index} />
                    </div>
                  ))}
                </div>

                {/* Right Button */}
                <div
                  className={`mx-2 ${
                    startIndex === data.length - oneVisibleTrip.length
                      ? "opacity-50 "
                      : ""
                  }`}
                  onClick={handleNextClickOneSection}
                  disabled={startIndex === data.length - oneVisibleTrip.length}
                >
                  <IconButton className="Primary_Light_Background hover:scale-110">
                    <ArrowForwardIosIcon />
                  </IconButton>
                </div>
              </div>

              {/* Bottom data Index bullets */}
              <div className="text-center pb-20">
                {data.map((element, index) => {
                  return (
                    <>
                      {index === startIndex ? (
                        <>
                          <RadioButtonCheckedIcon
                            key={index}
                            fontSize="small"
                            className="Primary_Main_Text"
                          />
                        </>
                      ) : (
                        <>
                          <RadioButtonUncheckedIcon
                            key={index}
                            fontSize="small"
                            className="Primary_Light_Text"
                          />
                        </>
                      )}
                    </>
                  );
                })}
              </div>
            </>
          )}
        </>
      )}

      {/* Modal */}
      {showModal && (
        <>
          <CancelCallModal
            showModal={showModal}
            setshowModal={setshowModal}
            cancelObject={cancelObject}
            cancelCall={cancelCall}
          />
        </>
      )}
    </>
  );
}

export default CallsArea;
